export default {
  pt:{
    nomeunidade: "Unidade de Recursos Humanos (URH)",
    menu:{
      apresentacao: "Apresentação",
      procedimentos: "Procedimentos Concursais",
      bolsas:"Bolsas de Investigação",
      documentacao: "Documentação e Legislação",
      atos: "Publicitação de Atos",
      siadap: "Avaliação de Desempenho",
      faq: "Perguntas Frequentes",
      formularios: "Formulários",
    },
    apresentacao:{
      horario: "Horário de Expediente",
      horariosecontactos: "Horário e Contactos",
      email: "Email",
      telefone: "Telefone",
      morada: "Morada",
      conhercerequipa: "Conhecer Equipa",
    },
    forms:{
      pesquisaforms: "Pesquisar Formulários"
    },
    relatoriocontas:{
      pesquisarelatorio: "Pesquisar Documentos",
      tiporelatio: "Tipo de relatorio"
    },
    informacoesmenu:{
      pesquisar: "Pesquisar Publicações"
    },
    regulamentosmenu:{
      pesquisar: "Pesquisar Regulamentos"
    },
    procedimentos:{
      pesquisa: "Pesquisar Procedimentos",
      vertodosprocedimentos: "Ver todos os procedimentos",
      edital: "Edital",
      designacao:"Designação",
      categoria: "Categoria Profissional",
      candidaturasate: "Candidaturas até",
      estado: "Estado",
      tipoconcurso: "Tipo de Concurso"
    },
    procedimento:{
      UMA_LANG_DOCSBOLSA_AREA_CIENTIFICA: "Área Científica",
      UMA_LANG_DOCSBOLSA_PERFIL_PROCEDIMENTO: "Designação do Cargo/Perfil do Candidato",
      UMA_LANG_DOCSBOLSA_LOCAL: "Local de Trabalho",
      UMA_LANG_DOCSBOLSA_DURACAO_PROCEDIMENTO: "Duração do Contrato",
      UMA_LANG_DOCSBOLSA_ESTADO_ACTUAL: "Estado Actual",
      UMA_LANG_DOCSBOLSA_UNIDADE: "Unidade Orgânica",
      UMA_LANG_DOCSBOLSA_CATEGORIAPROF: "Categoria Profissional",
      UMA_LANG_DOCSBOLSA_N_VAGAS: "Nº de Vagas",
      UMA_LANG_DOCSBOLSA_VAGA_DISPONIVEL: "Vaga Disponível",
      UMA_LANG_DOCSBOLSA_CANDIDATURASATE: "Candidaturas até",
      UMA_LANG_DOCSBOLSA_DATACONCLUSAO: "Data de Atribuição"
    },
    bolsas:{
      pesquisa: "Pesquisar Bolsas",
      vertodosprocedimentos: "Ver todas as bolsas",
      UMA_LANG_DOCSBOLSA_CODIGO:"Código da Bolsa",
      UMA_LANG_DOCSBOLSA_DESIGNACAO:"Designação",
      UMA_LANG_DOCSBOLSA_DATALIMITE:"Candidaturas até",
      UMA_LANG_DOCSBOLSA_ESTADO:"Estado",
    },
    atos:{
      tipoato: "Tipo de Ato",
      anosemestre: "Ano/Semestre",
      semestre: "semestre",
      pesquisa: "Pesquisar Atos"
    },
    siadap:{
      pesquisa: "Pesquisar Documentos"
    },
    list:{
      ano: "Ano",
      designacao: "Designação",
      documentos: "Documentos"
    },
    documentacao:{
      pesquisa: "Pesquisar Documentos"
    },
    semdocumentos: "Sem resultados para apresentar",
    apesquisar: "A pesquisar",
    horario: "Horário de Expediente",
    responsavel: "Responsavel",
    
    semnoticias: "Sem informação para apresentar",
    semdoc: "Sem ligações",
    informacoes: "Informações",
    titulodesc: "Título / Descrição",
    data: "Data",
    pesquisarDocs: "Pesquisar Ligações",
    breadcrumb:{
      homepage: "Homepage",
      sobre: "Sobre",
      admin: "Serviços Administrativos",
      sigla: "URH",
    }
  },
  en: {
    apresentacao:{
      horario: "Office Hours",
      horariosecontactos: "SCHEDULE AND CONTACTS",
      email: "Email",
      telefone: "Telephone",
      morada: "Address",
      conhercerequipa: "Meet the team",
    },
    nomeunidade: "Human Resources Unit",
    horariosecontactos: "SCHEDULE AND CONTACTS",
    email: "Email",
    telefone: "Telephone",
    morada: "Address",
    forms:{
      pesquisaforms: "Search for Forms"
    },
    relatoriocontas:{
      pesquisarelatorio: "Pesquisar Documentos",
      tiporelatio: "Tipo de relatorio"
    },
    informacoes:{
      pesquisar: "Pesquisar Publicações"
    },
    regulamentosmenu:{
      pesquisar: "Pesquisar Regulamentos"
    },
    procedimentos:{
      pesquisa: "Search for Procedures",
      vertodosprocedimentos: "See all Procedures",
      edital: "Edict",
      designacao:"Designation",
      categoria: "PROFESSIONAL CATEGORY",
      candidaturasate: "Applications Until",
      estado: "Status",
      tipoconcurso: "Procurement Type"
    },
    procedimento:{
      UMA_LANG_DOCSBOLSA_AREA_CIENTIFICA: "Scientific Area",
      UMA_LANG_DOCSBOLSA_PERFIL_PROCEDIMENTO: "Job Description/Applicant’s Profile",
      UMA_LANG_DOCSBOLSA_LOCAL: "Workplace",
      UMA_LANG_DOCSBOLSA_DURACAO_PROCEDIMENTO: "Contract’s Duration",
      UMA_LANG_DOCSBOLSA_ESTADO_ACTUAL: "Current Status",
      UMA_LANG_DOCSBOLSA_UNIDADE: "Organic Unit",
      UMA_LANG_DOCSBOLSA_CATEGORIAPROF: "Professional Category",
      UMA_LANG_DOCSBOLSA_N_VAGAS: "Number of vacancies",
      UMA_LANG_DOCSBOLSA_VAGA_DISPONIVEL: "Vaga Disponível",
      UMA_LANG_DOCSBOLSA_CANDIDATURASATE: "Applications Until",
      UMA_LANG_DOCSBOLSA_DATACONCLUSAO: "Assignment Date"
    },
    bolsas:{
      pesquisa: "Search for Scholarships",
      vertodosprocedimentos: "See all Scholarships",
      UMA_LANG_DOCSBOLSA_CODIGO:"SCHOLARSHIP CODE",
      UMA_LANG_DOCSBOLSA_DESIGNACAO:"DESIGNATION",
      UMA_LANG_DOCSBOLSA_DATALIMITE:"Applications Until",
      UMA_LANG_DOCSBOLSA_ESTADO:"Status",
    },
    atos:{
      tipoato: "Type of Act",
      anosemestre: "Year/Semester",
      semestre: "semester",
      pesquisa: "Search for Acts"
    },
    siadap:{
      pesquisa: "Search for Documents"
    },
    list:{
      ano: "Year",
      designacao: "Designation",
      documentos: "Documents"
    },
    documentacao:{
      pesquisa: "Search for Documents"
    },
    menu:{
      apresentacao: "Introduction",
      informacoes: "Informations",
      faq: "Frequently Asked Questions",
      formularios: "Forms",
      procedimentos: "Faculty & Staff Hiring Processes",
      bolsas:"Research Scholarships",
      documentacao: "Documentation and Legislation",
      atos: "Publication of Acts",
      siadap: "Performance Evaluation",
    },
    apesquisar: "Searching",
    horario: "Office Hours",
    responsavel: "Responsible Person",
    ligacoeslist:{
      ligacoes: "Ligações",
      titulo: "Título/Descrição",
      website: "Website"
    },
    semdocumentos: "No documents to be shown",
    conhercerequipa: "Get to know the team",
    semdoc: "Sem ligações",
    informacoes: "Informations",
    titulodesc: "Título / Descrição",
    data: "Date",
    pesquisarDocs: "Pesquisar Ligações",
    breadcrumb:{
      homepage: "Homepage",
      sobre: "About",
      admin: "Administrative Services",
      sigla: "HRU",
    }
  }
}